'use client'
import { useState, useEffect } from "react";

export default function Keywords(props) {
    const [placeholders, setPlaceholders] = useState([]);
    useEffect(() => {
        setPlaceholders(props.placeholders)
    }, [props.placeholders])
    return (
        <div>
            {placeholders?.map((word, index) => {
                return <div className="keywordrecrd" key={word.FieldName + "_" + index}><button key={word.FieldName} value={word.FieldName} onClick={() => props.wordClicked(word.FieldName, word.Fieldid)}>{word.FieldName}</button></div>
            })}
        </div>
    );
}
